import { cn } from "@/lib/cn";
import type { ReactNode } from "react";

/**
 * EmptyState — estado vacío sereno (no alarmista). Ícono opcional dibujado
 * (SVG), NUNCA emoji. Usalo para listas sin resultados, colas vacías, etc.
 */
export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-3 rounded-[var(--radius-app)]",
        "border border-dashed border-sand-300 bg-bone-50 px-6 py-12 text-center",
        className,
      )}
    >
      {icon && (
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-sand-100 text-ink-muted">
          {icon}
        </div>
      )}
      <div className="space-y-1">
        <p className="font-display text-lg text-ink">{title}</p>
        {description && (
          <p className="mx-auto max-w-sm text-sm text-ink-muted">
            {description}
          </p>
        )}
      </div>
      {action && <div className="mt-1">{action}</div>}
    </div>
  );
}
